import script from "./HandleArea.vue?vue&type=script&setup=true&lang=ts"
export * from "./HandleArea.vue?vue&type=script&setup=true&lang=ts"

import "./HandleArea.vue?vue&type=style&index=0&id=147e805b&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-147e805b"]])

export default __exports__